import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import { IAbout } from "@/types/page";
import adminAxios from "@/lib/axios";

export async function createAbout(payload: Partial<IAbout>) {
  try {
    const response = await adminAxios.post(ADMIN_API_ENDPOINTS.ABOUT.CREATE, payload);
    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateAbout(id: number, payload: Partial<IAbout>) {
  try {
    const response = await adminAxios.put(ADMIN_API_ENDPOINTS.ABOUT.UPDATE(id), payload);
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
